import { paperWidths } from '@/features/print/constants'

export const getPaperWidthOptions = (unit: string) =>
    paperWidths.reduce<{ [value: string]: string }>((options, paperWidth) => {
        options[paperWidth.toString()] = `${paperWidth.toString()} ${unit}`
        return options
    }, {})
